import React, { forwardRef } from 'react';

import MUITablePagination, {
  TablePaginationProps as MUITablePaginationProps,
} from '@material-ui/core/TablePagination';

import { useMUITheme } from '../styles/theme';
import { Icons } from '../Icon';
import { css } from '../../customEmotion';

const TablePagination = forwardRef<HTMLDivElement, MUITablePaginationProps>(
  (props, ref) => {
    const theme = useMUITheme();

    return (
      <MUITablePagination
        {...props}
        ref={ref}
        component="div"
        className={css`
          & .Mui-focused .MuiSelect-icon {
            color: ${theme.palette.grey[500]};
          }
        `}
        SelectProps={{
          variant: 'outlined',
          IconComponent: Icons.KeyboardArrowDown,
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: -theme.spacing(1),
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            className: css`
              & .MuiPaper-root {
                box-shadow: none;
                border: 1px solid ${theme.palette.grey[500]};
              }

              & .MuiMenuItem-root:hover {
                background-color: ${theme.palette.grey.A400};
                color: ${theme.palette.grey[700]};
              }

              & .MuiMenuItem-root.Mui-selected {
                background-color: ${theme.palette.grey[100]};
                color: ${theme.palette.grey[700]};
              }
            `,
          },
        }}
      />
    );
  }
);

export default TablePagination;
